import { RECRUITERDASHBOARDJOBCOUNT } from "../../ENVIRONMENT";

// api for recruiter job count
function recruiterjobcount(token) {
  const response = fetch(RECRUITERDASHBOARDJOBCOUNT, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { recruiterjobcount };
